/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: { currentUser?: API.CurrentUser } | undefined,
) {
  const { currentUser } = initialState ?? {};
  const preMap:any = currentUser?.permissions?.reduce((pre: any, cur) => {
    if(!cur.action.includes('plugin::user-admin-plugin.')) return pre
    const key = cur.action?.replace('plugin::user-admin-plugin.', '');
    pre[key] = true;
    return pre;
  }, {});
  console.log(preMap, 'pre');
  return {
    ...preMap
  };
}
